// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_3VkSR","dangerous":"view-default_dangerous_Uj6O6"};